var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonedas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 160C85.96 160 0 195.8 0 240v192C0 476.2 85.96 512 192 512s192-35.82 192-80v-192C384 195.8 298 160 192 160zM352 432c0 12.34-55.01 48-160 48s-160-35.66-160-48v-51.81C66.39 401.8 125.2 416 192 416s125.6-14.24 160-35.81V432zM352 336c0 12.34-55.01 48-160 48s-160-35.66-160-48V284.2C66.39 305.8 125.2 320 192 320s125.6-14.24 160-35.81V336zM192 288C87.01 288 32 252.3 32 240S87.01 192 192 192s160 35.66 160 48S296.1 288 192 288zM320 0C224 0 128 26.36 128 79.09v32.13c0 8.881 7.156 16.07 16 16.07S160 120.1 160 111.2V79.09c0-19.19 63.81-48.19 160-48.19s160 29.01 160 48.19c0 14.31-39.5 38.22-113.6 45.86c-8.252 .8523-14.37 7.826-14.37 15.96c0 13.83 13.2 16.09 15.96 16.09c5.268 0 71.08-6.493 112-31.8v34.22c0 8.816-16.47 23.28-52.59 34.18c-6.927 2.091-11.41 8.465-11.41 15.37c0 1.537 .2221 3.1 .6887 4.648C418.8 220.6 425.1 225.1 432 225.1c5.233 0 30.28-8.46 48-19.48v34.16c0 8.816-16.47 23.28-52.59 34.18c-6.927 2.091-11.41 8.465-11.41 15.37c0 1.537 .2221 3.1 .6887 4.648C418.8 300.9 425.1 305.4 432 305.4c1.882 0 80-18.58 80-65.64V79.09C512 26.36 416 0 320 0z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonedas);
export default __webpack_public_path__ + "static/media/monedas.09a0c3eb.svg";
export { ForwardRef as ReactComponent };